module.exports = __webpack_public_path__ + "static/media/Leitbild.614cfa81.pdf";